module.exports = __webpack_public_path__ + "img/954ba1a.png";